import { arbitrum, base, bsc, mainnet, optimism, polygon, sepolia, unichain, zksync, } from 'viem/chains';
export const ALL_SUPPORTED_CHAINS = [
    mainnet,
    sepolia,
    arbitrum,
    polygon,
    base,
    bsc,
    optimism,
    zksync,
    unichain,
];
//# sourceMappingURL=chains.js.map